// The backend accepts post codes in the Polish \d{2}-\d{3} format only.
const POST_CODE_DIGITS = 5;
const PREFIX_LENGTH = 2;

export const formatPostCode = (value: string): string => {
  const digits = value.replace(/\D/gu, "").slice(0, POST_CODE_DIGITS);

  if (digits.length <= PREFIX_LENGTH) {
    return digits;
  }

  return `${digits.slice(0, PREFIX_LENGTH)}-${digits.slice(PREFIX_LENGTH)}`;
};

// BFormInput binds value to the model, so an unchanged model would leave the raw input in the DOM.
export const postCodeInputFormatter = (value: string, event?: Event): string => {
  const formatted = formatPostCode(value);
  const target = event?.target as HTMLInputElement | null | undefined;

  if (target && target.value !== formatted) {
    target.value = formatted;
  }

  return formatted;
};
